import React from "react";
import {
  Box,
  Button,
  Modal,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";
import { theme } from "styles/theme";

interface ReleaseNote {
  version: string;
  status: "deployed" | "draft";
  // 배포일 — 미배포(draft)면 없음.
  date?: string;
  notes: string[];
}

// TODO(배포 기능): 서버의 프로그램 버전 목록으로 대체 예정 — 일단 mock.
// 최신 버전이 맨 앞. 편집기가 보고 있는 작업 버전은 v1.0.0 (미배포).
const MOCK_RELEASE_NOTES: ReleaseNote[] = [
  {
    version: "v1.0.0",
    status: "draft",
    notes: ["디스턴싱 프로그램 v0 전체를 cowork로 옮겨오는 중"],
  },
  {
    version: "v0.0.1",
    status: "deployed",
    date: "2026-06-12",
    notes: ["전체 유저 적용", "cowork 호환 안됨"],
  },
];

interface ProgramVersionModalProps {
  open: boolean;
  onClose: () => void;
}

// 프로그램 버전 목록 모달 — 버전별 배포 상태 + 릴리즈 노트.
export function ProgramVersionModal({
  open,
  onClose,
}: ProgramVersionModalProps) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        sx={{
          width: "min(90vw, 480px)",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            mb: 1,
          }}
        >
          <Typography level="title-md" sx={{ fontWeight: 700 }}>
            프로그램 릴리즈 노트
          </Typography>
          <ModalClose sx={{ position: "static" }} />
        </Box>
        <Box sx={{ overflowY: "auto", minHeight: 0 }}>
          {MOCK_RELEASE_NOTES.map((release) => (
            <Box key={release.version} sx={{ mb: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <Typography
                  level="title-sm"
                  sx={{
                    fontSize: "14px",
                    fontWeight: 700,
                    color: theme.vars.palette.Content.Strong,
                  }}
                >
                  {release.version}
                </Typography>
                {/* 배포 완료 칩 — 미배포(작업 중) 버전은 칩·날짜 없이 버전만 */}
                {release.status === "deployed" && (
                  <Typography
                    level="body-xs"
                    sx={{
                      fontSize: "10px",
                      lineHeight: 1,
                      px: "5px",
                      py: "3px",
                      borderRadius: "999px",
                      border: `1px solid ${theme.vars.palette.text.green}`,
                      color: theme.vars.palette.text.green,
                    }}
                  >
                    배포 완료
                  </Typography>
                )}
                {release.date && (
                  <Typography
                    level="body-xs"
                    sx={{
                      ml: "auto",
                      fontSize: "11px",
                      color: theme.vars.palette.Content.Weak,
                    }}
                  >
                    {release.date}
                  </Typography>
                )}
              </Box>
              <Box component="ul" sx={{ m: "8px 0 0", pl: "18px" }}>
                {release.notes.map((note) => (
                  <Typography
                    key={note}
                    component="li"
                    level="body-sm"
                    sx={{
                      fontSize: "12px",
                      lineHeight: "20px",
                      color: theme.vars.palette.Content.Medium,
                    }}
                  >
                    {note}
                  </Typography>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
          <Button size="sm" variant="Plain" color="primary" onClick={onClose}>
            확인
          </Button>
        </Box>
      </ModalDialog>
    </Modal>
  );
}
